// extracted by mini-css-extract-plugin
export var textInput = "_ix-0";